const ROLE_SETTINGS_BY_NEW_ROLE_ID = {
  4: {
    legacyRole: "TECHNICIAN",
    canEditPoints: false,
    isAtp: true,
    corporate: false,
  },
  5: {
    legacyRole: "ADMIN",
    canEditPoints: true,
    isAtp: false,
    corporate: true,
  },
  6: {
    legacyRole: "BILLING",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  7: {
    legacyRole: "BILLING",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  8: {
    legacyRole: "AREA_MANAGER",
    canEditPoints: false,
    isAtp: false,
    corporate: false,
  },
  9: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: true,
    isAtp: false,
    corporate: true,
  },
  10: {
    legacyRole: "BUSINESS_SUPPORT",
    canEditPoints: true,
    isAtp: false,
    corporate: true,
  },
  13: {
    legacyRole: "COLLECTIONS",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  14: {
    legacyRole: "CUSTOMER_EXPERIENCE",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  15: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  16: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  17: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  18: {
    legacyRole: "CUSTOMER_EXPERIENCE",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  19: {
    legacyRole: "SERVICE_TEAM",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  20: {
    legacyRole: "SERVICE_TEAM",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  22: {
    legacyRole: "TECHNICIAN",
    canEditPoints: false,
    isAtp: false,
    corporate: false,
  },
  23: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: true,
    isAtp: false,
    corporate: true,
  },
  24: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  25: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  26: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: true,
    isAtp: false,
    corporate: true,
  },
  27: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: true,
    isAtp: false,
    corporate: true,
  },
  28: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  29: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  30: {
    legacyRole: "OFFICE_SUPPORT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  31: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  32: {
    legacyRole: "FINANCE",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  35: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  36: {
    legacyRole: "FOLLOWUP",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  38: {
    legacyRole: "WAREHOUSE_TECHNICIAN",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  40: {
    legacyRole: "OFFICE_SUPPORT",
    canEditPoints: false,
    isAtp: false,
    corporate: false,
  },
  41: {
    legacyRole: "OFFICE_SUPPORT",
    canEditPoints: false,
    isAtp: false,
    corporate: false,
  },
  42: {
    legacyRole: "PATIENT_CARE_REP",
    canEditPoints: false,
    isAtp: false,
    corporate: false,
  },
  43: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  44: {
    legacyRole: "OFFICE_SUPPORT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  45: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  46: {
    legacyRole: "OFFICE_SUPPORT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  47: {
    legacyRole: "PURCHASING",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  48: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  49: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  50: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  51: {
    legacyRole: "AREA_MANAGER",
    canEditPoints: false,
    isAtp: false,
    corporate: false,
  },
  52: {
    legacyRole: "SALES_MANAGER",
    canEditPoints: false,
    isAtp: true,
    corporate: false,
  },
  53: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: true,
    corporate: false,
  },
  55: {
    legacyRole: "SALES_MANAGER",
    canEditPoints: false,
    isAtp: true,
    corporate: false,
  },
  56: {
    legacyRole: "SALES",
    canEditPoints: false,
    isAtp: false,
    corporate: false,
  },
  57: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  58: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  59: {
    legacyRole: "MARKETING_MANAGER",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  60: {
    legacyRole: "ADMIN",
    canEditPoints: true,
    isAtp: true,
    corporate: true,
  },
  61: {
    legacyRole: "EXECUTIVE_MANAGEMENT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  62: {
    legacyRole: "USER_ADMIN",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  63: {
    legacyRole: "ADMIN",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  64: {
    legacyRole: "OFFICE_SUPPORT",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  65: {
    legacyRole: "MARKETING_MANAGER",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  66: {
    legacyRole: "MARKETING",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
  67: {
    legacyRole: "REGIONAL_OPERATIONS_MANAGER",
    canEditPoints: false,
    isAtp: false,
    corporate: false,
  },
  77: {
    legacyRole: "SALES_MANAGER",
    canEditPoints: false,
    isAtp: true,
    corporate: false,
  },
  78: {
    legacyRole: "PURCHASING",
    canEditPoints: false,
    isAtp: false,
    corporate: true,
  },
};

export default ROLE_SETTINGS_BY_NEW_ROLE_ID;
